exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "electra-header, electra-search-wrapper {\n  height: 100%;\n  position: absolute;\n  width: 100%; }\n\nelectra-search-wrapper {\n  height: 100%;\n  right: 0;\n  transition: opacity 0.25s ease; }\n\nelectra-search-wrapper.hide {\n  opacity: 0;\n  pointer-events: none; }\n\nelectra-search-wrapper.desktop {\n  right: 20px;\n  max-width: 560px;\n  width: 40%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/electraLib/component/headerWrapper/headerWrapper.component.scss
// module id = 405
// module chunks = 1